// extracted by mini-css-extract-plugin
export default {"tutorialBG":"TutorialStyles_tutorialBG__Q13F0","show":"TutorialStyles_show__MVsKg","tutorial":"TutorialStyles_tutorial__PTPps","skipCount":"TutorialStyles_skipCount__tRRWm"};